import * as React from 'react';
import { Box } from '@mui/material';
import { Header } from '@components';
import theme from 'config/theme';

const Main = ({ open, onToggleDrawer, children }) => {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        paddingTop: theme.customValues.topBarHeight,
        paddingBottom: 0,
        margin: 0,
        width: open
          ? `calc(100vw - ${theme.customValues.drawerWidth})`
          : `calc(100vw - ${theme.customValues.closedDrawerWidth})`,
        maxWidth: '100%',
      }}
    >
      <Header open={open} onToggleDrawer={onToggleDrawer} />
      {children}
    </Box>
  );
};

export default Main;
